import { destroySlider, initSlider, visibilityItem } from './slider-util';

export const initCategoriesSlider = () => {
    const selector = '.categories-slider';
    const sliderConfig = {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: true
    };
    let sliderEl = null;

    visibilityItem(selector);
    window.require(['matchMedia', 'slick'], (mediaCheck) => {
        mediaCheck({
            media: '(min-width: 768px)',
            entry: () => {
                if (sliderEl) return;

                sliderEl = initSlider(selector, sliderConfig);
            },
            exit: () => {
                if (!sliderEl) return;

                destroySlider(sliderEl);
                sliderEl = null;
            }
        });
    });
};
